import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  static targets = ["hiddenTab"]

  connect() {
    this.shownHandler = this.onShown.bind(this)
    this.element.addEventListener("shown.bs.tab", this.shownHandler)

    const requested = new URLSearchParams(window.location.search).get("tab")
    if (!requested) return

    const trigger = this.element.querySelector(`button[data-bs-target="#nav-${requested}"]`)
    if (trigger && window.bootstrap) {
      window.bootstrap.Tab.getOrCreateInstance(trigger).show()
    }
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.tab", this.shownHandler)
  }

  onShown(event) {
    const tabName = event.target.getAttribute("data-bs-target").replace("#nav-", "")

    if (this.hasHiddenTabTarget) this.hiddenTabTarget.value = tabName

    const url = new URL(window.location.href)
    url.searchParams.set("tab", tabName)
    window.history.replaceState({}, "", url)
  }
}
